import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "../utils/exportPDF";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const PurchaseItemsList = () => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [purchasesExport, setPurchasesExport] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(false);
  const [user_id, setUserId] = useState("");
  const [kitchenIddd, setKitchenId] = useState(null);
  const [purchaseTotals, setPurchaseTotals] = useState({});

  const [filters, setFilters] = useState({
    vendor: "",
    invoice: "",
    purchaseBy: "",
    item: "",
    startDate: "",
    endDate: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedPurchase, setSelectedPurchase] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [stockVendor, setVendor] = useState([]);
  const [stockItems, setStockItems] = useState([]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;
    if (user.kitchen) {
      setKitchenId(user.kitchen);
    }
    if (user.user_id) {
      setUserId(user.user_id);
    }
  }, []);

  // Fetch vendors and stock items
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await axios.get(
          "https://ims-backend.indevconsultancy.in/admin-panel/vendor/"
        );
        if (Array.isArray(res.data)) setVendor(res.data);
        else if (res.data?.data) setVendor(res.data.data);
      } catch (err) {
        console.error("Error fetching vendors:", err);
      }
    };

    const fetchStockItems = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user?.kitchen) return;

        const res = await axios.get(
          `https://api-ims.indevconsultancy.in/purchase_report_listing_export.php?kitchen_id=${user.kitchen}`
        );

        if (res.data?.success) {
          let items = res.data.data || [];
          const uniqueItems = Object.values(
            items.reduce((acc, item) => {
              if (!acc[item.items_id]) {
                acc[item.items_id] = {
                  items_id: item.items_id,
                  stock_name: item.stock_name.trim(),
                  vendor_name: item.vendor_name?.trim(),
                  invoice_no: item.invoice_no,
                  date: item.date,
                  parchase_by: item.parchase_by,
                  images: JSON.parse(item.images || "[]"),
                  quantity: item.quantity,
                  unit: item.unit,
                  total_amount: item.total_amount,
                };
              }
              return acc;
            }, {})
          );
          setStockItems(uniqueItems);
        }
      } catch (err) {
        console.error("Error fetching stock items:", err);
      }
    };

    fetchVendors();
    fetchStockItems();
    fetchPurchases(1); // Fetch first page on initial load
    fetchPurchasesExport();
  }, []);

  // Fetch purchases with proper pagination
  const fetchPurchases = async (page = 1) => {
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.kitchen) return;

      const params = {
        user_id,
        vendor: filters.vendor,
        invoice_no: filters.invoice,
        purchase_by: filters.purchaseBy,
        item_id: filters.item,
        start_date: filters.startDate,
        end_date: filters.endDate,
        page: page,
        limit: itemsPerPage,
        kitchen_id: user.kitchen,
      };

      // Remove empty/null params
      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      const { data } = await axios.get(
        `https://api-ims.indevconsultancy.in/purchase_report_listing.php`,
        { params }
      );

      if (data?.success) {
        const allData = data.data || [];

        // Calculate pagination based on total data length
        const totalCount = allData.length;
        setTotalRecords(totalCount);
        setTotalPages(Math.ceil(totalCount / itemsPerPage));

        // Apply client-side pagination
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedData = allData.slice(startIndex, endIndex);

        setPurchases(paginatedData);
        setCurrentPage(page);
      } else {
        setPurchases([]);
        setTotalPages(0);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setPurchases([]);
      setTotalPages(0);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  // Alternative approach if your API supports server-side pagination
  const fetchPurchasesServerSide = async (page = 1) => {
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.kitchen) return;

      const params = {
        user_id,
        vendor: filters.vendor,
        invoice_no: filters.invoice,
        purchase_by: filters.purchaseBy,
        item_id: filters.item,
        start_date: filters.startDate,
        end_date: filters.endDate,
        page: page,
        per_page: itemsPerPage, // Use per_page instead of limit if needed
        kitchen_id: user.kitchen,
      };

      // Remove empty/null params
      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      const { data } = await axios.get(
        `https://api-ims.indevconsultancy.in/purchase_report_listing.php`,
        { params }
      );

      if (data?.success) {
        // If API returns paginated data directly
        setPurchases(data.data || []);

        // If API returns pagination info in response
        if (data.total_records) {
          setTotalRecords(data.total_records);
          setTotalPages(Math.ceil(data.total_records / itemsPerPage));
        } else if (data.total_count) {
          setTotalRecords(data.total_count);
          setTotalPages(Math.ceil(data.total_count / itemsPerPage));
        } else {
          // Fallback: calculate from data length
          const totalCount = data.data?.length || 0;
          setTotalRecords(totalCount);
          setTotalPages(Math.ceil(totalCount / itemsPerPage));
        }

        setCurrentPage(page);
      } else {
        setPurchases([]);
        setTotalPages(0);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setPurchases([]);
      setTotalPages(0);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchPurchasesExport = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.kitchen) return;

      const params = {
        vendor: filters.vendor,
        invoice_no: filters.invoice,
        purchase_by: filters.purchaseBy,
        item_id: filters.item,
        start_date: filters.startDate,
        end_date: filters.endDate,
        kitchen_id: user.kitchen,
      };

      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      const { data } = await axios.get(
        `https://api-ims.indevconsultancy.in/purchase_report_listing_export.php`,
        { params }
      );

      if (data?.success) {
        const exportData = data.data || [];
        setPurchasesExport(exportData);

        const totals = exportData.reduce((acc, item) => {
          const pid = item.parchase_id;
          const raw = item.total_amount ?? 0;
          const str = String(raw)
            .replace(/\r?\n|\r/g, "")
            .replace(/,/g, "")
            .trim();
          const amt = parseFloat(str) || 0;
          if (!pid) return acc;
          acc[pid] = (acc[pid] || 0) + amt;
          return acc;
        }, {});
        setPurchaseTotals(totals);
      } else {
        setPurchasesExport([]);
        setPurchaseTotals({});
      }
    } catch (error) {
      console.error("Error fetching purchases:", error);
      setPurchasesExport([]);
      setPurchaseTotals({});
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      fetchPurchases(newPage);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleView = async (parchase_id) => {
    setModalLoading(true);
    try {
      const response = await axios.post(
        "https://api-ims.indevconsultancy.in/purchase_report_viwe_item.php",
        { parchase_id }
      );
      setSelectedPurchase(response.data.data);
    } catch (error) {
      console.error("Error fetching purchase details:", error);
      setSelectedPurchase([]);
    } finally {
      setModalLoading(false);
      setShowModal(true);
    }
  };

  const handleExportCSV = () => {
    const headers = [
      "S.No.",
      "Vendor Name",
      "Item Name",
      "Invoice No",
      "Purchase Date",
      "Purchase By",
      "quantity",
      "Price",
      "total_amount",
    ];

    const rows = purchasesExport.map((item, index) => [
      index + 1,
      (item.vendor_name || "").trim(),
      (item.stock_name || "").trim(),
      (item.invoice_no || "").trim(),
      formatDate(item.date),
      (item.parchase_by || "").trim(),
      (item.quantity || "").trim(),
      (item.unit || "").trim(),
      (item.total_amount || "").trim(),
    ]);

    const escapeCSV = (field) => {
      if (field == null) return "";
      const str = field.toString().replace(/\r?\n|\r/g, " ");
      return str.includes(",") || str.includes('"')
        ? `"${str.replace(/"/g, '""')}"`
        : str;
    };

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((row) => row.map(escapeCSV).join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "purchase_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDF = () => {
    if (!purchasesExport.length) return alert("No data to export.");
    const headers = ["S.No.", "Vendor Name", "Item Name", "Invoice No", "Purchase Date", "Purchase By", "Quantity", "Price", "Total Amount"];
    const rows = purchasesExport.map((item, index) => [
      index + 1,
      (item.vendor_name || "").toString().trim(),
      (item.stock_name || "").toString().trim(),
      (item.invoice_no || "").toString().trim(),
      formatDate(item.date),
      (item.parchase_by || "").toString().trim(),
      (item.quantity || "").toString().trim(),
      (item.unit || "").toString().trim(),
      (item.total_amount || "").toString().trim(),
    ]);
    exportTableToPDF({ title: "Purchase Report List", headers, rows, filename: "purchase_list.pdf", filterInfo: `Total: ${rows.length}` });
  };

  const [modalImage, setModalImage] = useState(null);
  const handleImageClick = (imgUrl) => {
    setModalImage(imgUrl);
  };
  const closeModal = () => {
    setModalImage(null);
  };

  const handleReset = () => {
    setFilters({
      vendor: "",
      invoice: "",
      purchaseBy: "",
      item: "",
      startDate: "",
      endDate: "",
    });
    setCurrentPage(1);
    fetchPurchases(1);
    fetchPurchasesExport();
  };

  // Handle search form submission
  const handleSearch = (e) => {
    if (e) e.preventDefault();
    setCurrentPage(1);
    fetchPurchases(1);
    fetchPurchasesExport();
  };

  // Generate page numbers for pagination
  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="container-fluid px-2">
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <span className="fs-1">List Purchase Items</span>
        </div>
        <div className="col-md-6 col-6 text-end">
          <div className="bg-light p-2 rounded d-inline-flex align-items-center justify-content-end">
            <span className="me-1">List Purchase Items</span>
            <span className="mx-1">/</span>
            <Link to="/purchaseDashboard">Home</Link>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header border-info">
              <form onSubmit={handleSearch}>
                <div className="row g-3">
                  <div className="col-lg">
                    <select
                      className="form-control"
                      name="vendor"
                      value={filters.vendor}
                      onChange={handleChange}
                    >
                      <option value="">Vendor Name</option>
                      {stockVendor.map((vendor, index) => (
                        <option key={index} value={vendor.vendor_id}>
                          {vendor.vendor_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg">
                    <input
                      type="text"
                      name="invoice"
                      className="form-control"
                      placeholder="Invoice No."
                      value={filters.invoice}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <input
                      type="text"
                      name="purchaseBy"
                      className="form-control"
                      placeholder="Purchase By"
                      value={filters.purchaseBy}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <select
                      className="form-control"
                      name="item"
                      value={filters.item}
                      onChange={handleChange}
                    >
                      <option value="">Select Item</option>
                      {stockItems.map((item, index) => (
                        <option key={index} value={item.items_id}>
                          {item.stock_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg">
                    <input
                      type="date"
                      name="startDate"
                      className="form-control"
                      value={filters.startDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <input
                      type="date"
                      name="endDate"
                      className="form-control"
                      value={filters.endDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-primary w-100">
                      Search
                    </button>
                  </div>
                  <div className="col-lg-1">
                    <button
                      type="button"
                      className="btn btn-outline-dark w-100"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="card-body">
              <div className="row g-0 align-items-center">
                <div className="col-sm-6 mb-3">
                  <h6 className="fw-bold mb-0">
                    Total Items: <span>{totalRecords}</span>
                    {totalRecords > 0 && (
                      <span className="text-muted ms-2">
                        (Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                        {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords})
                      </span>
                    )}
                  </h6>
                </div>
                <div className="col-sm-6 mb-3 text-end px-3">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    type="button"
                    onClick={() => navigate("/PurchaseItemsList")}
                  >
                    All Items List
                  </button>

                  <button
                    className="btn btn-primary btn-sm me-2"
                    type="button"
                    onClick={() => navigate("/PurchaseReport")}
                  >
                    <i className="fas fa-plus me-1"></i> Add
                  </button>

                  <button
                    className="btn btn-success btn-sm"
                    type="button"
                    onClick={handleExportCSV}
                  >
                    <i className="fas fa-file-export me-1"></i> Export CSV
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    type="button"
                    onClick={handleExportPDF}
                  >
                    <i className="fas fa-file-pdf me-1"></i> Export PDF
                  </button>
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive scrollbar">
                <table className="table text-center table-bordered table-striped fs--1 mb-0">
                  <thead className="bg-primary text-white">
                    <tr>
                      <th>Purchase.No</th>
                      <th>Vendor Name</th>
                      <th>Invoice No.</th>
                      <th>Date</th>
                      <th>Purchase By</th>
                      <th>Total Amount</th>
                      <th>Images</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : purchases.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center py-4">
                          No data available
                        </td>
                      </tr>
                    ) : (
                      purchases.map((purchase, index) => (
                        <tr key={purchase.parchase_id}>
                          <td>PU00{purchase.parchase_id}</td>
                          <td>{purchase.vendor_name || "N/A"}</td>
                          <td>{purchase.invoice_no}</td>
                          <td>{formatDate(purchase.date)}</td>
                          <td>{purchase.parchase_by}</td>
                          <td>
                            {purchaseTotals[purchase.parchase_id] != null
                              ? Number(
                                purchaseTotals[purchase.parchase_id]
                              ).toFixed(2)
                              : purchase.total_amount != null
                                ? (
                                  Number(
                                    String(purchase.total_amount).replace(
                                      /,/g,
                                      ""
                                    )
                                  ) || 0
                                ).toFixed(2)
                                : "0.00"}
                          </td>
                          <td>
                            {purchase.images && purchase.images.length > 0 ? (
                              <img
                                src={
                                  "https://api-ims.indevconsultancy.in/" +
                                  purchase.images[0]
                                }
                                alt="purchase"
                                width={100}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleImageClick(
                                    "https://api-ims.indevconsultancy.in/" +
                                    purchase.images[0]
                                  )
                                }
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge ${purchase.status === "1"
                                ? "bg-success"
                                : "bg-danger"
                                }`}
                            >
                              {purchase.status === "1" ? "Received" : "Pending"}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2 justify-content-center">
                              <button
                                className="btn btn-primary btn-sm"
                                type="button"
                                onClick={() => handleView(purchase.parchase_id)}
                              >
                                <i className="fas fa-eye"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* Enhanced Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    <span className="text-muted">
                      Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                      {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords} entries
                    </span>
                  </div>

                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handlePageChange(1)}
                      disabled={currentPage === 1}
                    >
                      First
                    </button>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>

                    {generatePageNumbers().map(page => (
                      <button
                        key={page}
                        className={`btn btn-sm ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    ))}

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    >
                      Last
                    </button>
                  </div>

                  <div>
                    <span className="text-muted">
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Purchase Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="table-responsive scrollbar">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Purchase ID</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modalLoading ? (
                        <tr>
                          <td colSpan="5">Loading...</td>
                        </tr>
                      ) : selectedPurchase.length === 0 ? (
                        <tr>
                          <td colSpan="5">No data available</td>
                        </tr>
                      ) : (
                        selectedPurchase.map((item) => (
                          <tr key={item.items_id || item.id}>
                            <td>{item.parchase_id || "N/A"}</td>
                            <td>{item.stock_name || "N/A"}</td>
                            <td>{item.quantity}</td>
                            <td>{item.unit}</td>
                            <td>{item.total_amount}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {modalImage && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          onClick={closeModal}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-body text-center">
                <img src={modalImage} alt="purchase" className="img-fluid" />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseItemsList;